import { render, staticRenderFns } from "./RedirectMessageLink.vue?vue&type=template&id=0b7da60b&"
import script from "./RedirectMessageLink.vue?vue&type=script&lang=js&"
export * from "./RedirectMessageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports